import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ConnectToyotaPage } from './connect-toyota.page';

const routes: Routes = [
  {
    path: '',
    component: ConnectToyotaPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConnectToyotaPageRoutingModule {}
